import * as React from 'react';
import { UpgradeColumn } from './UpgradeColumn';
import { UpgradePlanBillingPeriod } from './UpgradePlanBillingPeriod';
import { UpgradeToPremium } from './UpgradeToPremium';
import { v4PlanColumnDatas } from '../../../constants/pricing';

interface UpgradePlanProps {
  checkoutSummaryRef: any;
}

export const UpgradePlan = ({ checkoutSummaryRef }: UpgradePlanProps) => {
  const [showFeatures, setShowFeatures] = React.useState(false);
  const [selected, setSelected] = React.useState('standard-plan-4');
  const handleClick = () => setShowFeatures(!showFeatures);
  const { lite, standard, premium } = v4PlanColumnDatas;
  const columnDatas = [lite, standard, premium];

  const columns = columnDatas.map((columnData) => (
    <UpgradeColumn
      key={columnData.name}
      columnData={columnData}
      showFeatures={showFeatures}
      selected={selected}
      setSelected={setSelected}
      checkoutSummaryRef={checkoutSummaryRef}
    />
  ));

  const isCustomSelected = selected === 'custom';
  return (
    <>
      <div className="upgrade-plan-title body">
        <p className="fsz-24 bold-900 pa-20">
          Upgrade Plan
        </p>
      </div>
      <div className="upgrade-plan-section body pa-20">
        <div className="flex-col justify-between width-100">
          <div className="item-header">
            <p className="orange bold-900">Plan</p>
          </div>
          <div className="column-container">{columns}</div>
          <span
            tabIndex={0}
            role="button"
            className="center link-blue mt-15"
            onClick={handleClick}
            onKeyPress={handleClick}
            style={{ cursor: 'pointer' }}
          >
            { showFeatures ? 'Hide Feature List' : 'Show Features List' }
          </span>
        </div>
      </div>
      { isCustomSelected ? <UpgradeToPremium /> : <UpgradePlanBillingPeriod /> }
    </>
  );
};
